
export enum GatewayStyleEnum {
    IOTMAXX = 'IOTMAXX', JUCONN = 'JUCONN'
}
